import React, { useState } from "react";
import { CSVLink } from "react-csv"; // Install with `npm install react-csv`
import "./LeadsTable.css";
import { useEffect } from "react";
import { auth, db } from "../../FirebaseConfig";
import { doc, getDoc } from "firebase/firestore";

const LeadsTable = ({ leads }) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Filter leads based on search input
  const filteredLeads = leads.filter(
    (lead) =>
      lead.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.status.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // CSV headers
  const headers = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "phone" },
    { label: "Status", key: "status" },
    { label: "Referral ID", key: "referralId" },
    { label: "Date", key: "createdAt" },
  ];
  const [role, setRole]=useState('')
  useEffect(() => {
    const handleLogin = async () => {
      try {
        // Fetch user data from Firestore
        const userDocRef = doc(db, "influencers", auth.currentUser.uid);
        const userDocSnap = await getDoc(userDocRef);
    
        if (userDocSnap.exists()) {
          const userData = userDocSnap.data();
    setRole(userData.role)
         console.log(userData.role)
        } else {
          throw new Error("User data not found in Firestore");
        }
      } catch (err) {
        console.error(err);
      
      }
    };
    handleLogin()
  }, [auth])
  
  return (
    <div className="leads-table-container">
      <h2>All Leads</h2>

      {/* Search Bar */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by name, email, or status..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {role!='admin'?'':<CSVLink
          data={leads}
          headers={headers}
          filename={"leads.csv"}
          className="export-btn"
        >
          Export CSV
        </CSVLink>}
      </div>

      {/* Leads Table */}
      <table className="leads-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Status</th>
            <th>Referral ID</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredLeads.length > 0 ? (
            filteredLeads.map((lead, index) => (
              <tr key={index}>
                <td>{lead.name}</td>
                <td>{role!='admin'?'***':lead.email}</td>
                <td>{role!='admin'?'***':lead.phone}</td>
                <td>{role!='admin'?'***':lead.status}</td>
                <td>{lead.referralId}</td>
                <td>{new Date(lead.createdAt).toLocaleDateString()}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No leads found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LeadsTable;
